import { render, staticRenderFns } from "./BulkTrashArticles.vue?vue&type=template&id=7dea3ce0"
import script from "./BulkTrashArticles.vue?vue&type=script&lang=js"
export * from "./BulkTrashArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports